import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
			<div className="bg-white rounded-2xl shadow-lg p-10 max-w-md text-center">
				<h1 className="text-6xl font-bold text-gray-700 mb-4">404</h1>
				<h2 className="text-2xl font-semibold mb-4">Page introuvable</h2>
				<p className="text-gray-600 mb-8">
					La ressource que vous recherchez n&apos;existe pas.
				</p>
				<button
					onClick={() => navigate('/app', { replace: true })}
					className="bg-gray-700 hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
				>
					Retour à l&apos;accueil
				</button>
			</div>
		</div>
	);
};

export default NotFound;
